import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { encryptedStorage } from 'src/utils/storage'

import {
  AnalysisTypeEnum,
  BiReportTypeEnum,
  ReportingToolTypes,
} from 'src/components/organisms/reporting-tool/schemas'

type ReportingToolFilterStore = {
  options: object
  clear: () => void
  filters: ReportingToolTypes
  setOptions: (options: object) => void
  setFilters: (newFilters: ReportingToolTypes) => void
  summary: { filters?: string; exceptions?: string }
  setSummary: (newSummary: { filters?: string; exceptions?: string }) => void
}

export const useReportingToolFilterStore = create<ReportingToolFilterStore>()(
  persist(
    (set) => ({
      filters: {
        companyIds: [],
        analysisType: 'DA' as AnalysisTypeEnum,
        biReportType: 'invoiced' as BiReportTypeEnum,
      },
      options: {},
      setOptions: (newOptions: object) =>
        set((state) => ({ ...state, options: newOptions })),
      setFilters: (newFilters: ReportingToolTypes) =>
        set((state) => ({ ...state, filters: newFilters })),
      summary: {},
      setSummary: (newSummary: { filters?: string; exceptions?: string }) => {
        set((state) => ({ ...state, summary: newSummary }))
      },
      clear: () =>
        set({
          filters: {
            companyIds: [],
            analysisType: 'DA' as AnalysisTypeEnum,
            biReportType: 'invoiced' as BiReportTypeEnum,
          },
        }),
    }),
    {
      name: 'reporting-tool-filter-storage',
      storage: encryptedStorage(),
      partialize: (state) => ({
        filters: state.filters,
        summary: state.summary,
      }),
    }
  )
)
